
function initSwathOpacitySlider() {
  const _self = this;
  let timer_id = null;
  //Init Slider bar.
  (function( $ ) {
    'use strict';

    if ( $.isFunction($.fn[ 'slider' ]) ) {
      $(function() {
        $('[data-plugin-slider]').each(function() {
          let $this = $( this ),
              opts = {};

          let pluginOptions = $this.data('plugin-options');
          if (pluginOptions) {
            opts = pluginOptions;
          }

          $this.themePluginSlider(opts);
        });
      });
    }
  }).apply(this, [ jQuery ]);

  $('#listenSlider').change(function() {
    let opacity = (Number(this.value)/100);
    $('.slider-output b').text( opacity );
    if(timer_id) {
      clearTimeout(timer_id);
    }
    timer_id = setTimeout(() => {
      timer_id = null;
      _self.props.updateSwathOpacity(opacity);
    }, 200);
  });
}

export default initSwathOpacitySlider;



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/utils/initSwathOpacitySlider.js